export { default } from './ParallaxSection'
